<template>
    <div class="" style="box-sizing: border-box">
        <div class="header_warpper">
            <div class="left">
                <el-tabs v-model="query.type" @tab-click="handleDateTabClick" style="margin-right: 10px">
                    <el-tab-pane label="全部" name="0"></el-tab-pane>
                    <el-tab-pane label="今日" name="1"></el-tab-pane>
                    <el-tab-pane label="昨日" name="2"></el-tab-pane>
                    <el-tab-pane label="本周" name="3"></el-tab-pane>
                    <el-tab-pane label="上周" name="4"></el-tab-pane>
                    <el-tab-pane label="本月" name="5"></el-tab-pane>
                    <el-tab-pane label="上月" name="6"></el-tab-pane>
                </el-tabs>
                <el-input v-model="query.seek" placeholder="单号/备注" style="margin-left: 68px"></el-input>
                <el-button type="primary" style="margin-right: 10px" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button plain @click="dialogVisible = !dialogVisible" style=""
                    >{{ $t('common.filter') }}<i class="el-icon-arrow-up el-icon--right" v-if="!dialogVisible"></i>
                    <i class="el-icon-arrow-down el-icon--right" v-else></i>
                </el-button>
            </div>

            <div class="right" style="">
                <el-button type="" plain @click="handleRefresh">{{ $t('common.refresh') }}</el-button>
                <el-button type="primary" @click="handleAdd" style="margin-right: 10px">{{ $t('common.add') }}</el-button>
                <el-dropdown trigger="click" @command="handleCommand">
                    <el-button plain> 更多<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">{{ $t('common.audit') }}</el-dropdown-item>
                        <el-dropdown-item command="5">反审</el-dropdown-item>
                        <el-dropdown-item command="2">{{ $t('common.export') }}</el-dropdown-item>
                        <el-dropdown-item command="3">{{ $t('common.print') }}</el-dropdown-item>
                        <el-dropdown-item command="4">{{ $t('common.delete') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <!-- 筛选面板：常用条件 / 高级筛选 -->
        <div v-show="dialogVisible" class="dialog_warpper">
            <div class="dialog">
                <el-tabs v-model="activeName" @tab-click="handleFilterTabChange">
                    <el-tab-pane label="常用条件" name="0">
                        <div class="box2">
                            <div style="margin-top: 15px" class="block">
                                <p>日期</p>
                                <el-radio-group v-model="query.type" size="medium" @input="handleDateTypeChange">
                                    <el-radio-button label="1">今日</el-radio-button>
                                    <el-radio-button label="2">昨日</el-radio-button>
                                    <el-radio-button label="3">本周</el-radio-button>
                                    <el-radio-button label="4">上周</el-radio-button>
                                    <el-radio-button label="5">本月</el-radio-button>
                                    <el-radio-button label="6">上月</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="block">
                                <p class="demonstration">自定义</p>
                                <el-date-picker
                                    v-model="value2"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    style="width: 80%"
                                    @change="handleDateRangeChange"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </div>
                            <div class="block">
                                <p class="demonstration">{{ $t('common.billType') }}</p>
                                <el-select
                                    v-model="query.billtype_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.billtype"
                                        :key="index"
                                        :label="item.billtype_no + ' - ' + item.billtype_name"
                                        :value="item.billtype_no.toString()"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="block">
                                <p>{{ $t('common.auditStatus') }}</p>
                                <el-radio-group v-model="query.check">
                                    <el-radio label="0">{{ $t('common.all') }}</el-radio>
                                    <el-radio label="未审核">未审核</el-radio>
                                    <el-radio label="已审核">已审核</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="block">
                                <p class="demonstration">成品柜台</p>
                                <el-select
                                    v-model="query.product_counter_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.counter"
                                        :key="index"
                                        :label="item.counter_no + ' - ' + item.counter_name"
                                        :value="item.counter_no"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="block">
                                <p class="demonstration">物料柜台</p>
                                <el-select
                                    v-model="query.bom_counter_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.counter"
                                        :key="index"
                                        :label="item.counter_no + ' - ' + item.counter_name"
                                        :value="item.counter_no"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="block">
                                <p class="demonstration">经手人</p>
                                <el-select
                                    v-model="query.staff_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.staff"
                                        :key="index"
                                        :label="item.staff_no + ' - ' + item.staff_name"
                                        :value="item.staff_no"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="高级筛选" name="1">
                        <div class="box1">
                            <!-- 新增一行筛选条件 -->
                            <el-button type="success" icon="el-icon-plus" plain circle @click="addFilterRow"></el-button>
                            <div
                                style="margin-top: 20px; display: flex; flex-wrap: wrap; align-items: center"
                                v-for="(tag, index) in bonusData"
                                :key="index"
                            >
                                <el-select
                                    @change="handleFilterFieldChange(index, $event)"
                                    v-model="bonusData[index].field"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    style="width: 150px"
                                >
                                    <el-option
                                        v-for="item in pullData.screen_pull[0].field"
                                        :key="item.name_no"
                                        :label="item.name"
                                        :value="item.name_no"
                                    ></el-option>
                                </el-select>
                                <span style="display: inline-block; margin: 0 10px">-</span>
                                <el-select
                                    v-model="bonusData[index].condition"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    style="width: 150px"
                                >
                                    <el-option
                                        v-for="item in pullData.screen_condition"
                                        :key="item.name_no"
                                        :label="item.name"
                                        :value="item.name_no"
                                    ></el-option>
                                </el-select>
                                <span style="display: inline-block; margin: 0 10px">-</span>
                                <!-- 有下拉选项的字段显示下拉框，否则显示文本输入框 -->
                                <el-select
                                    v-model="bonusData[index].parameter"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    v-if="Array.isArray(arrs[index]) && arrs[index].length > 0"
                                    style="width: 150px"
                                >
                                    <el-option
                                        v-for="item in arrs[index]"
                                        :key="item.kind_no"
                                        :label="item.kind_name"
                                        :value="item.kind_no"
                                    ></el-option>
                                </el-select>
                                <el-input style="width: 150px" v-model="bonusData[index].parameter" placeholder="请输入" v-else></el-input>
                                <!-- 删除当前筛选条件行 -->
                                <el-button
                                    style="margin-left: 15px"
                                    type="danger"
                                    icon="el-icon-minus"
                                    plain
                                    circle
                                    @click.native.prevent="removeFilterRow(index)"
                                    size="small"
                                ></el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmFilter">确 定</el-button>
            </span>
        </div>
        <div class="table">
            <vxe-table
                border
                auto-resize
                :data="backData"
                ref="table"
                height="620"
                :footer-method="footerMethod"
                show-footer
                :key="refushTable"
            >
                <vxe-table-column type="checkbox" fixed="left" width="50" align="center"></vxe-table-column>
                <vxe-table-column title="序号" type="seq" field="seq" fixed="left" width="50" align="center">
                    <template slot="header">
                        <!-- 打开列配置抽屉 -->
                        <i class="el-icon-setting" style="font-size: 18px" @click="openColumnSetting"></i>
                    </template>
                </vxe-table-column>
                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :key="item.field + index"
                        :field="item.field"
                        :title="item.column_name"
                        align="left"
                        :width="item.column_width"
                        v-if="item.column_status == 1 && item.column_name != '单号' && item.column_name != '审核'"
                    >
                    </vxe-table-column>
                    <vxe-table-column
                        :key="item.field + index"
                        :prop="item.field"
                        :label="item.column_name"
                        :width="item.column_width"
                        v-else-if="item.column_name == '单号' && item.column_status == 1"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleViewDetail(scope.row)">{{ scope.row[item.field] }}</el-button>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        :key="item.field + index"
                        :prop="item.field"
                        :label="item.column_name"
                        :width="item.column_width"
                        v-else-if="item.column_name == '审核' && item.column_status == 1"
                    >
                        <template #default="{ row }">
                            <el-tag :type="row.check == 1 ? 'success' : 'danger'">{{ row.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</el-tag>
                        </template>
                    </vxe-table-column>
                </template>

                <template #empty>
                    <span style="color: red">
                        <img src="@/assets/img/dontHave.png" style="width: 180px" />
                    </span>
                </template>
            </vxe-table>
            <div class="pagination" style="text-align: right">
                <vxe-pager
                    :current-page.sync="query.page"
                    :page-size.sync="query.page_size"
                    :total="pageTotal"
                    :perfect="true"
                    :page-sizes="[10, 20, 30, 40, { label: '全部', value: 100000000 }]"
                    :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </div>
        </div>

        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select
                v-model="queryForm.model_name"
                placeholder="请选择模板"
                filterable
                clearable
                @change="handlePrintTemplateChange"
                style="width: 150px"
            >
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name" :value="item.id">
                </el-option>
            </el-select>
            <div v-loading="loading" class="printBox" id="print" ref="print" style="page-break-after: always; padding: 10px">
                <div v-for="(itemBig, index) in printList" style="margin-bottom: 30px" :key="index">
                    <div
                        style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                        v-if="DataDtl.company.is_show == 1"
                    >
                        <p class="company" v-if="systemSet.company" :style="`font-size:${DataDtl.company.font_size}px;`">
                            {{ systemSet.company }}
                        </p>
                    </div>
                    <div v-if="DataDtl.title">
                        <div v-if="DataDtl.title.is_show == 1">
                            <p class="printTitle" :style="`font-size:${DataDtl.title.font_size}px;`">
                                {{ itemBig.mains ? itemBig.mains.billtype_name : '' }}
                            </p>
                        </div>
                    </div>
                    <div v-if="DataDtl.header">
                        <div v-if="DataDtl.header.is_show == 1">
                            <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                                <div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户：{{ itemBig.mains ? itemBig.mains.cust_name : '' }}
                                    </div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">
                                        备注：{{ itemBig.mains ? itemBig.mains.remark : '' }}
                                    </div>
                                </div>
                                <div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单号：{{ itemBig.mains ? itemBig.mains.bill_no : '' }}
                                    </div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">
                                        日期：{{ itemBig.mains ? itemBig.mains.bill_date : '' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="itemBig.dtls.length != [] && DataDtl.is_fields1 == 1"
                        :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`"
                    >
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <p class="tableName">
                                <span v-if="DataDtl.table_name1_show == 1">{{ DataDtl.table_name1 }}</span>
                            </p>
                            <p style="font-size: 12px"><label>打印时间：</label>{{ itemBig.mains.print_time }}</p>
                        </div>
                        <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields1">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtls" :key="index">
                                <template v-for="items in fields1">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table1_total_show == 1">
                                <template v-for="(items, indexs) in fields1">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtls_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div v-if="itemBig.dtlGroupBy && DataDtl.is_fields3 == 1" :style="`margin-bottom:${DataDtl.table3_bottommargin}px;`">
                        <p class="tableName">
                            <span v-if="DataDtl.table_name3_show == 1">{{ DataDtl.table_name3 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields3_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields3">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtlGroupBy" :key="index">
                                <template v-for="items in fields3">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.no == 'bill_mode'"
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no + '_name'] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :key="items.seq"
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table3_total_show == 1">
                                <template v-for="(items, indexs) in fields3">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtlGroupBy_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div
                        v-if="itemBig.bills.length != [] && DataDtl.is_fields2 == 1"
                        :style="`margin-bottom:${DataDtl.table2_bottommargin}px;`"
                    >
                        <p class="tableName">
                            <span v-if="DataDtl.table_name2_show == 1">{{ DataDtl.table_name2 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields2_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields2">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.bills" :key="index">
                                <template v-for="items in fields2">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.no == 'bill_mode'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no + '_name'] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :key="items.seq"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table2_total_show == 1">
                                <template v-for="(items, indexs) in fields2">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.bills_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div v-if="DataDtl.is_tot">
                        <div v-if="DataDtl.is_tot.is_show == 1">
                            <div class="summoney">
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                        >总计 金额大写 {{ itemBig.mains.money_type }}</span
                                    >
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money_chinese }}</span>
                                </div>
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                        >金额合计&nbsp;&nbsp;&nbsp; {{ itemBig.mains.money_type }}</span
                                    >
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.custaccounts_begin">
                        <div
                            class="sum2"
                            v-if="DataDtl.custaccounts_begin.is_show == 1"
                            :style="`font-size:${DataDtl.custaccounts_begin.font_size}px;`"
                        >
                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期初存欠帐（正欠负存）:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p
                                    style="width: 25%; display: flex; justify-content: space-between"
                                    v-for="(item, index) in itemBig.custaccounts_begin"
                                    :key="index"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="DataDtl.custaccounts_end">
                        <div
                            class="sum2"
                            v-if="DataDtl.custaccounts_end.is_show == 1"
                            :style="`font-size:${DataDtl.custaccounts_end.font_size}px;`"
                        >
                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期末存欠帐（正欠负存）:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p
                                    style="width: 25%; display: flex; justify-content: space-between"
                                    v-for="(item, index) in itemBig.custaccounts_end"
                                    :key="index"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="DataDtl.custaccounts_now">
                        <div
                            class="sum2"
                            v-if="DataDtl.custaccounts_now.is_show == 1"
                            :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"
                        >
                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p
                                    style="width: 25%; display: flex; justify-content: space-between"
                                    v-for="(item, index) in itemBig.custaccounts_now"
                                    :key="index"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.footer">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="sumBotn" style="width: 72%; margin-right: 8%">
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>制单：</span>
                                    <span>{{ itemBig.mains.build_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>复核：</span>
                                    <span></span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>业务员：</span>
                                    <span>{{ itemBig.mains.salesman_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>客户签名：</span>
                                    <span></span>
                                </div>
                            </div>

                            <div style="display: inline-block; text-align: right; width: 20%">
                                <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 10px" v-if="DataDtl.remark.is_show == 1">
                    <p :style="`font-size:${DataDtl.remark.font_size}px;`">{{ DataDtl.remark.content }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="downloadAsImage">转图片下载</el-button>
                <el-button type="primary" @click="handleDirectPrint">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列配置抽屉：已显示字段可拖拽排序/移除，可选字段可点击添加 -->
        <el-drawer title="我是标题" :visible.sync="drawers" direction="rtl" :with-header="false">
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="handleColumnToggle('del', index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="handleColumnToggle('add', index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="handleColumnCancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="handleColumnConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    apiBarcodesAssemblyDelsData,
    apiBarcodesAssemblychecks,
    apiBarcodesAssemblyGetOrderList,
    apiBarcodesAssemblyGetPull,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    getPrinOut_pull,
    apiBarcodesAssemblyPrint
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';

// 当前页面表格列配置项 ID（列配置读取/保存接口使用）
const COLUMN_CONFIG_ID = '143';

// 默认查询条件（刷新时重置使用）
const DEFAULT_QUERY = {
    page: 1,
    page_size: 10,
    seek: '',
    type: '1',
    start_date: '',
    end_date: '',
    check: '0',
    return: 0
};

export default {
    name: 'BarcodesAssemblyHistory',
    data() {
        return {
            // ---------- 列表查询 ----------
            query: { ...DEFAULT_QUERY }, // 列表查询条件（分页/关键字/日期/审核状态）
            pageTotal: 0, // 数据总条数
            backData: [], // 列表数据
            systemSet: '', // 系统参数设置（控制表尾合计的小数位数）
            // ---------- 筛选面板 ----------
            dialogVisible: false, // 是否展开筛选面板
            activeName: '0', // 筛选面板当前页签（0 常用条件 / 1 高级筛选）
            value2: '', // 自定义日期范围
            bonusData: [], // 高级筛选条件列表（字段/条件/参数）
            arrs: [], // 高级筛选各行字段对应的下拉选项（按行索引存储，空数组表示使用输入框）
            pullData: {}, // 筛选条件下拉数据（单据类型/柜台/经手人/高级筛选字段等）
            // ---------- 表格列配置 ----------
            rkKeyList: [], // 表格列配置（已按当前语言转换列名）
            originalRkKeyList: [], // 原始表格列配置（含所有语言，语言切换时重新转换）
            refushTable: true, // 表格 key，取反强制刷新表格
            drawers: false, // 是否打开列配置抽屉
            keyList: [], // 抽屉内编辑的列配置副本
            showIndex: null, // 已显示字段当前悬停的行索引（控制删除图标显隐）
            optionalIndex: null, // 可选字段当前悬停的行索引（控制添加图标显隐）
            // ---------- 打印相关 ----------
            printData: { isshow: false }, // 打印弹框显示状态
            pullList: {}, // 打印模板下拉数据
            queryForm: {}, // 当前选中的打印模板（model_name）
            printType: '', // 当前打印模板名称（转图片下载时的文件名）
            printList: {}, // 待打印单据数据列表
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} }, // 打印模板明细配置（各区域显隐/字号/表格字段）
            fields1: [], // 打印第一张表格的字段配置
            fields2: [], // 打印第二张表格的字段配置
            fields3: [], // 打印第三张表格的字段配置（按单据分组汇总）
            loading: false, // 打印内容区加载状态
            img: '' // 打印内容转换后的图片数据（base64）
        };
    },
    mounted() {
        // 读取系统参数设置（数量/重量/金额小数位数）
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getOrderList();
        this.getFilterOptions();
        this.getPrintOptions();
        this.getColumnConfig();
        // 监听语言变化，重新翻译表格列名
        this.$watch(
            () => (this.$i18n ? this.$i18n.locale : localStorage.getItem('language')),
            (newLang) => {
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    methods: {
        /* ==================== 数据加载 ==================== */

        /**
         * 获取单据列表数据（携带高级筛选条件）
         */
        getOrderList() {
            apiBarcodesAssemblyGetOrderList({
                ...this.query,
                screen: this.buildScreenParam()
            }).then((res) => {
                this.backData = res.data.data;
                this.pageTotal = res.data.count;
            });
        },

        /**
         * 构建高级筛选条件 screen 参数（仅日期范围为“全部”时生效）
         */
        buildScreenParam() {
            if (this.query.type != 0 || this.bonusData.length === 0) {
                return '';
            }
            return JSON.stringify(this.bonusData);
        },

        /**
         * 获取筛选条件下拉数据（单据类型/柜台/经手人/高级筛选字段等）
         */
        getFilterOptions() {
            apiBarcodesAssemblyGetPull({}).then((res) => {
                this.pullData = res.data;
            });
        },

        /**
         * 获取打印模板下拉数据，并默认选中后端配置的模板
         */
        getPrintOptions() {
            getPrinOut_pull({ code: this.$route.query.page }).then((res) => {
                this.pullList = res.data;
                this.queryForm.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },

        /**
         * 获取表格列配置，并按当前语言转换列名（保留原始多语言数据）
         */
        getColumnConfig() {
            apiGetListCorrespondingData({ id: COLUMN_CONFIG_ID }).then((res) => {
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言），语言切换时重新翻译
                    this.originalRkKeyList = res.data;
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },

        /* ==================== 表格列配置抽屉 ==================== */

        /**
         * 打开列配置抽屉（深拷贝当前列配置，避免确认前影响表格展示）
         */
        openColumnSetting() {
            this.drawers = true;
            this.keyList = JSON.parse(JSON.stringify(this.rkKeyList));
        },

        /**
         * 切换列的显示/隐藏
         * @param {String} type del 隐藏该列 / add 显示该列
         * @param {Number} index 列在 keyList 中的索引
         */
        handleColumnToggle(type, index) {
            this.$set(this.keyList[index], 'column_status', type === 'add' ? '1' : '0');
        },

        /**
         * 取消列配置：关闭抽屉并重新拉取服务端列配置（丢弃本地修改）
         */
        handleColumnCancel() {
            this.drawers = false;
            this.getColumnConfig();
        },

        /**
         * 确认列配置：保存后强制刷新表格使新配置生效
         */
        handleColumnConfirm() {
            apiUpdateListCorrespondingData({
                column: JSON.stringify(this.keyList),
                id: COLUMN_CONFIG_ID
            }).then((res) => {
                this.drawers = false;
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    // 切换表格 key 强制重新渲染表格
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        /* ==================== 搜索与筛选 ==================== */

        /**
         * 自定义日期范围变化：选择后清除快捷日期；清空后恢复默认“今日”
         */
        handleDateRangeChange(value) {
            if (value) {
                this.query.type = '';
                this.query.start_date = value[0];
                this.query.end_date = value[1];
            } else {
                this.query.type = '1';
                this.query.start_date = '';
                this.query.end_date = '';
            }
        },

        /**
         * 切换快捷日期单选（今日/昨日/本周等），同步清空自定义日期范围（仅重置，不查询）
         */
        handleDateTypeChange() {
            this.value2 = '';
            this.query.start_date = '';
            this.query.end_date = '';
        },

        /**
         * 切换筛选面板页签：回到“常用条件”时清空高级筛选条件，避免残留条件影响查询
         */
        handleFilterTabChange() {
            if (this.activeName == '0') {
                this.bonusData = [];
            }
        },

        /**
         * 确认筛选：高级筛选下日期需切换为“全部”才能使条件生效
         */
        confirmFilter() {
            this.dialogVisible = false;
            if (this.activeName == '1') {
                this.query.type = '0';
            }
            this.getOrderList();
        },

        /**
         * 新增一行高级筛选条件（字段/条件/参数）
         */
        addFilterRow() {
            this.bonusData.push({ field: '', condition: '', parameter: '' });
        },

        /**
         * 高级筛选字段变化时，加载该字段对应的参数下拉选项；
         * 字段无下拉选项时置空数组，模板中会自动切换为文本输入框（$set 保证按索引赋值响应式）
         */
        handleFilterFieldChange(index, fieldNo) {
            const field = this.pullData.screen_pull[0].field.find((item) => item.name_no == fieldNo);
            this.$set(this.arrs, index, field && field.select ? field.select : []);
        },

        /**
         * 删除一行高级筛选条件，并同步移除该行的参数选项，保持两个数组索引对齐
         */
        removeFilterRow(index) {
            this.bonusData.splice(index, 1);
            this.arrs.splice(index, 1);
        },

        /**
         * 切换顶部快捷日期页签（全部/今日/昨日等）并查询，同时清空自定义日期范围
         */
        handleDateTabClick() {
            this.value2 = '';
            this.query.start_date = '';
            this.query.end_date = '';
            this.getOrderList();
        },

        /**
         * 关键字搜索（单号/备注），搜索时清空高级筛选条件
         */
        handleSearch() {
            this.bonusData = [];
            this.getOrderList();
        },

        /**
         * 刷新：重置查询条件为默认值（含自定义日期范围）并重新加载列表
         */
        handleRefresh() {
            this.query = { ...DEFAULT_QUERY };
            this.value2 = '';
            this.getOrderList();
        },

        /* ==================== 批量操作 ==================== */

        /**
         * 获取勾选行的 ID 逗号拼接字符串（未勾选时返回空字符串）
         */
        getSelectedIds() {
            return this.$refs.table
                .getCheckboxRecords()
                .map((item) => item.id)
                .join(',');
        },

        /**
         * 导出 Excel：携带当前筛选条件，剔除分页参数导出全部符合条件数据，
         * 通过副本剔除分页字段，避免直接修改 this.query 导致列表分页失效
         */
        exportExcel() {
            const query = { ...this.query };
            delete query.page;
            delete query.page_size;
            this.$axios({
                url: this.$baseURL + 'index_barcodesin',
                method: 'post',
                data: {
                    id: this.getSelectedIds(),
                    is_exports: '1',
                    ...query,
                    screen: this.buildScreenParam()
                },
                responseType: 'arraybuffer'
            }).then((res) => {
                // 创建 blob 对象并通过 a 标签触发下载
                const blob = new Blob([res.data], { type: 'application/x-xls' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = '条码入库.xlsx';
                link.click();
            });
        },
        /**
         * “更多”下拉命令分发：1 审核 / 2 导出 / 3 打印 / 4 删除 / 5 反审
         */
        handleCommand(command) {
            if (command == 1) {
                this.handleBatchAudit(1);
            } else if (command == 5) {
                this.handleBatchAudit(0);
            } else if (command == 2) {
                this.exportExcel();
            } else if (command == 3) {
                this.loadPrintData(true);
            } else if (command == 4) {
                this.handleBatchDelete();
            }
        },

        /**
         * 批量审核/反审（需先勾选数据）
         * @param {Number} checkStatus 1 审核 / 0 反审
         */
        handleBatchAudit(checkStatus) {
            if (this.$refs.table.getCheckboxRecords().length === 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            apiBarcodesAssemblychecks({
                id: this.getSelectedIds(),
                check: checkStatus
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getOrderList();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        /**
         * 批量删除勾选数据（需二次确认，失败时逐行展示不可删除原因）
         */
        handleBatchDelete() {
            if (this.$refs.table.getCheckboxRecords().length === 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            this.$confirm('确定要删除选择数据吗？', '提示', { type: 'warning' })
                .then(() => {
                    apiBarcodesAssemblyDelsData({ id: this.getSelectedIds() }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getOrderList();
                        } else {
                            // 将各条不可删除原因用换行拼接，以 HTML 形式长驻展示
                            const errMsg = (res.data.info || []).join('<br/>');
                            this.$message({
                                type: 'error',
                                showClose: true,
                                duration: 0,
                                dangerouslyUseHTMLString: true,
                                message: errMsg
                            });
                        }
                    });
                })
                .catch(() => {});
        },

        /* ==================== 打印 ==================== */

        /**
         * 加载打印数据（单据数据 + 模板配置）
         * @param {Boolean} showDialog 加载完成后是否打开打印弹框
         * @param {Boolean} allowFallback 失败时是否回退默认模板重试（切换模板场景）
         */
        loadPrintData(showDialog = false, allowFallback = false) {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiBarcodesAssemblyPrint({
                id: this.getSelectedIds(),
                print_id: this.queryForm.model_name
            }).then((res) => {
                loading.close();
                if (res.code == 2000) {
                    if (showDialog) {
                        this.printData.isshow = true;
                    }
                    // 单据打印数据
                    this.printList = res.data.bill;
                    // 打印模板明细配置（区域显隐/字号/三张表格字段）
                    this.DataDtl = res.data.print;
                    this.fields1 = this.DataDtl.fields1;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields3 = this.DataDtl.fields3;
                } else if (allowFallback) {
                    // 当前模板加载失败时，回退系统默认模板重试（成功后打开弹框）
                    this.getPrintOptions();
                    this.loadPrintData(true);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        /**
         * 切换打印模板：更新模板名称/编号后重新加载打印数据，失败时回退默认模板（无需 $forceUpdate，数据变更会自动重渲染）
         */
        handlePrintTemplateChange(val) {
            const model = (this.pullList.model || []).find((item) => item.id == val);
            if (model) {
                this.printType = model.name;
            }
            this.queryForm.model_name = val;
            this.loadPrintData(false, true);
        },

        /**
         * 直接打印（调用全局打印插件）
         */
        handleDirectPrint() {
            this.$print(this.$refs.print);
        },

        /**
         * 打印内容转图片并下载（以模板名作为文件名）
         */
        downloadAsImage() {
            this.$html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                this.img = canvas.toDataURL();
                this.downloadFile(this.printType + '.png', this.img);
            });
        },

        /**
         * 通过 a 标签触发文件下载
         * @param {String} fileName 下载文件名
         * @param {String} content base64 编码的文件内容
         */
        downloadFile(fileName, content) {
            const aLink = document.createElement('a');
            const blob = this.base64ToBlob(content);
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);
            // 使用 dispatchEvent 模拟点击，兼容火狐
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        },

        /**
         * base64 数据转 Blob 对象
         */
        base64ToBlob(code) {
            const parts = code.split(';base64,');
            const contentType = parts[0].split(':')[1];
            const raw = window.atob(parts[1]);
            const uInt8Array = new Uint8Array(raw.length);
            for (let i = 0; i < raw.length; i++) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },

        /* ==================== 表尾合计与分页 ==================== */

        /**
         * 表尾合计行：数量/重量/金额类字段按系统参数小数位合计，其余列展示“-”
         */
        footerMethod({ columns, data }) {
            // 参与合计的字段与系统参数小数位键的对应关系（qty 数量 / wgt 重量 / amt 金额）
            const precisionMap = {
                sumqty: 'qty',
                sumwgt: 'wgt',
                sumamt: 'amt',
                balprc_qty: 'qty',
                balqty_wgt: 'wgt',
                tran_qty: 'qty',
                tran_wgt: 'wgt'
            };
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    }
                    const precisionKey = precisionMap[column.property];
                    if (!precisionKey) {
                        return '-';
                    }
                    return `${this.$utils.sum(data, column.property).toFixed(this.systemSet[precisionKey])}`;
                })
            ];
        },

        /**
         * 分页变化（页码/每页条数）后重新查询列表
         */
        handlePageChange({ currentPage, pageSize }) {
            this.query.page = currentPage;
            this.query.page_size = pageSize;
            this.getOrderList();
        },

        /* ==================== 页面跳转 ==================== */

        /**
         * 跳转新建单据页（组装单录入页）
         */
        handleAdd() {
            this.$router.push({
                path: '/' + this.$route.query.page,
                query: { isadd: '0' }
            });
        },

        /**
         * 点击单号跳转单据详情页（携带单号）
         */
        handleViewDetail(row) {
            this.$router.push({
                path: '/' + this.$route.query.page,
                query: { bill_no: row.bill_no }
            });
        }
    }
};
</script>

<style scoped lang="scss">
/deep/.el-tabs__nav-wrap::after {
    background-color: #fff;
}
/deep/.el-tabs__item {
    width: 66px;
    text-align: center;
    padding: 0;
    font-size: 12px;
}
/deep/.el-tabs__active-bar {
    width: 66px !important;
}
/deep/.el-drawer__header {
    border-bottom: 1px solid #e7e7e7;
    color: #000;
    font-size: 16px;
    margin: 0;
    padding: 15px 20px;
}
.header_warpper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 0 15px;
    padding-top: 15px;
    box-sizing: border-box;
    .left {
        display: flex;
        align-items: center;
    }
}
.drawer {
    width: 100%;
    height: 100%;
    position: relative;
}
.dialog-footer {
    width: 100%;
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-top: 1px solid #e7e7e7;
    text-align: right;
    height: 56px;
    line-height: 56px;
    padding: 0 20px;
    box-sizing: border-box;
}
.dialog_warpper {
    background-color: #fff;
    padding: 15px;
    box-sizing: border-box;
    margin: 15px 0;
    min-height: 400px;
    position: relative;
    padding-bottom: 56px;
}
.box1 {
    width: 600px;
    margin-top: 10px;
}
.box2 {
    width: 520px;
}
.dialog {
    .block {
        display: flex;
        margin-bottom: 15px;
        p {
            display: inline-block;
            width: 88px;
            color: #666;
            font-size: 14px;
        }
    }
}
.table {
    background-color: #fff;
    padding: 15px;
    box-sizing: border-box;
}
/deep/.el-tabs__header {
    margin-bottom: 0;
}
</style>
